export const SMS_CONSENT_PRIVACY_DISCLOSURE =
  "You understand that standard SMS messaging are not confidential methods of communication and may be insecure, meaning there is a risk that standard, unsecured SMS messaging regarding your medical care could be intercepted and read by a third party.";
